export default __webpack_public_path__ + "static/media/2.fadb4294.jpg";